export default {
  step: state => state.step,
  error: state => state.error
};
